<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span
          i.fa-solid.fa-shop
      h1 Café con Encanto

    .bloque-texto-g.color-acento-contenido.p-3.p-sm-4.p-md-5
      .bloque-texto-g__img
        .video-wrapper
          iframe(
            width="100%",
            height="100%",
            src="https://www.youtube.com/embed/lze758fNf7U?si=2Q86dnLUJPgCdjup",
            title="YouTube video player",
            frameborder="0",
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
            allowfullscreen
          )
      .bloque-texto-g__texto.p-4
        p.mb-0 "Café con Encanto" será un espacio acogedor y moderno enfocado en la venta de cafés especiales, cafés tradicionales y preparados con métodos de filtrado artesanales. Además, ofrecerá una línea gourmet de repostería casera que incluye cheesecake de sabores, galletas artesanales, tortas de zanahoria, rollitos de canela y una preparación especial de plátanos maduros con helado. El objetivo es ofrecer experiencias sensoriales únicas, combinando calidad, presentación y ambiente.

    .row.justify-content-center.align-items-center
      .col-sm-auto.text-center
        a.boton.color-acento-botones(href="https://maps.app.goo.gl/fgsR16tftCuVAy8y8" target="_blank")
          span.text-black Clic para ver ubicacion
          i.fa-solid.fa-location-dot.text-black

    
    h4.mt-5 Nombre: Café con Encanto
    p 
      b #[i Eslogan: "Un rincón para saborear, sentir y sonreír"]

    separador
    #t_1_1.titulo-segundo.color-acento-contenido
      h2 Misión

    p Ofrecer a nuestros clientes una experiencia única alrededor del café y la repostería artesanal, en un ambiente encantador, cómodo y lleno de calidez, resaltando los sabores locales y técnicas tradicionales con un toque contemporáneo.

    separador
    #t_1_1.titulo-segundo.color-acento-contenido
      h2 Visión

    p Ser reconocidos a nivel local y regional como el café de referencia para los amantes del buen café y la repostería artesanal, destacando por nuestra calidad, atención y ambiente.

    separador
    #t_1_1.titulo-segundo.color-acento-contenido
      h2 Productos y Servicios

    .titulo-tres.mt-5.margin-menos.mb-4: h3 Cafés:

    ul.lista-ul--color
      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Tradicionales: Tinto, café con leche, espresso, capuchino, americano.

      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Especiales: Mocca, latte vainilla, café con leche condensada, café con crema batida.

      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-3 Métodos de filtrado: Chemex, V60, Prensa Francesa, Aeropress, Cold Brew.

    .titulo-tres.mt-5.margin-menos.mb-4: h3 Repostería:

    ul.lista-ul--color
      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Cheesecakes de sabores: frutos rojos, maracuyá, oreo, limón, chocolate.


      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Galletas artesanales: chocolate chips, avena, nuez, jengibre.



      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Torta de zanahoria con nuez y glaseado de queso crema.



      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Rollitos de canela glaseados.



      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-3 Brownies y pastelitos variados.

    .titulo-tres.mt-5.margin-menos.mb-4: h3 Especialidad de la casa:

    ul.lista-ul--color
      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Plátanos maduros caramelizados con helado de vainilla y sirope de chocolate o caramelo.



    separador
    #t_1_1.titulo-segundo.color-acento-contenido
      h2 Diseño del local

    ul.lista-ul--color
      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Estilo rústico moderno con madera, luces cálidas, decoración botánica.

      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Espacios cómodos para sentarse solo o en grupo.

      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Wi-Fi gratuito, enchufes en mesas, música suave.

      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Mostrador visible para ver el proceso del café.

      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Mobiliario: mesas de madera, sillas cómodas, estanterías con productos locales.


    .tarjeta.bg-2.p-4
      SlyderA(tipo="b")

        .row.justify-content-center.align-items-center.my-lg-4
          .col-md-8
            figure
              img(src='@/assets/curso/cafeEncanto/img1.jpeg', alt='')

        .row.justify-content-center.align-items-center.my-lg-4
          .col-md-8
            figure
              img(src='@/assets/curso/cafeEncanto/img2.jpeg', alt='')

        .row.justify-content-center.align-items-center.my-lg-4
          .col-md-8
            figure
              img(src='@/assets/curso/cafeEncanto/img3.jpeg', alt='')

        .row.justify-content-center.align-items-center.my-lg-4
          .col-md-8
            figure
              img(src='@/assets/curso/cafeEncanto/img4.jpeg', alt='')

    separador
    #t_1_1.titulo-segundo.color-acento-contenido
      h2 Propuesta de valor

    ul.lista-ul--color
      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Café de origen colombiano preparado con métodos tradicionales y especiales.

      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Repostería casera de alta calidad hecha a diario.


      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-0 Ambiente encantador y acogedor para relajarse o trabajar.


      li.d-flex
        i.fas.fa-coffee
        .contenido
          p.mb-3 Servicio amable y personalizado.


    h4.text-center.mt-4 "Café con Encanto" busca ser más que una cafetería: una experiencia sensorial, estética y emocional para cada visitante. Con un enfoque en la calidad, el ambiente y el trato humano, el negocio se posicionará rápidamente como un referente en la ciudad para disfrutar el café y la repostería artesanal con verdadero encanto.}













</template>

<script>
export default {
  name: 'Tema3',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
